import React, { useState } from "react";

export interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  placeholderSrc?: string;
  className?: string;
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  placeholderSrc,
  className = "",
  style,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ display: "inline-block", ...style }}
    >
      {!loaded && (
        <>
          {placeholderSrc ? (
            <img
              src={placeholderSrc}
              alt={alt}
              className="absolute inset-0 w-full h-full object-cover blur-md scale-105 transition-opacity duration-500"
              style={{ zIndex: 1 }}
              aria-hidden="true"
            />
          ) : (
            <div className="absolute inset-0 w-full h-full bg-zinc-100 animate-pulse z-[1]">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
            </div>
          )}
        </>
      )}

      {/* عکس اصلی پروژه */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`w-full h-full object-cover transition-opacity duration-500 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        style={{ zIndex: 2 }}
        {...props}
      />
    </div>
  );
};

export default LazyImage;
